const BlogcommentsPage = () => import('./index.vue')
import { EditorGuard } from '@/common/guard'

export default [
  {
    path: '/blogcomments',
    beforeEnter: EditorGuard,
    component: BlogcommentsPage,
    name: 'BlogcommentsIndex'
  }
]
